import { Alert, Center, Loader, Paper, Stack } from '@mantine/core';
import { IconAlertTriangle } from '@tabler/icons-react';
import { FinancialSectionTable } from 'src/financial/financial-data/rework/FinancialSectionTable';
import { FamilyMember } from './useFamilyMembers';
import { useFamilyFinancialItems } from './useFamilyFinancialItems';

export function FamilyFinancialPanel({ members }: { members: FamilyMember[] }) {
  const { categories, isLoading, hasErrors } = useFamilyFinancialItems(members);

  return (
    <Stack gap="lg">
      {hasErrors && (
        <Alert
          variant="light"
          color="yellow"
          icon={<IconAlertTriangle size={18} />}
          title="Some data could not be loaded"
        >
          Financial data for one or more family members failed to load, so the totals below may be
          incomplete.
        </Alert>
      )}
      {isLoading ? (
        <Paper variant="content">
          <Center py="xxl">
            <Loader />
          </Center>
        </Paper>
      ) : (
        categories.map(category => (
          <FinancialSectionTable
            key={category.key}
            title={category.title}
            rows={category.rows}
            total={category.total}
            totalLabel={category.totalLabel}
            subSections={category.subSections}
            showMember
            addAction={{ onAdd: () => {} }}
            hideTotal={category.key === 'protections'}
          />
        ))
      )}
    </Stack>
  );
}
